import img1 from "@assets/voucherConfigImg/frame_1.png";
import img2 from "@assets/voucherConfigImg/frame_2.png";
import img3 from "@assets/voucherConfigImg/frame_3.png";
import ModulesHeader from "@components/common/ModulesHeader";
import { useIsTablet } from "@components/mediaQuery/useIsMobile";
import { checkPermission } from "@utils/permissions";
import { useState } from "react";
import { useSelector } from "react-redux";
import CustomerCard from "./CustomerCard";
import { VouchersConfigModal } from "./VouchersConfigModal";

const customers = [
	{
		id: "optishield",
		title: "OPTISHIELD",
		photo: img1,
		description:
			"Cybersecurity toolkit enabling top-tier protection for remote networks while facilitating IMO compliance on board.",
		features: [
			{
				label: "Advanced Protection",
				text: "Prevents exploits and advanced malware with sandbox integration and real-time threat monitoring.",
			},
			{
				label: "Secure",
				text: "Utilises SSL/IPSec VPN with two-factor authentication to ensure safe remote access.",
			},
			{
				label: "Data Protection",
				text: "Prevents data leaks, enforces compliance with GDPR/HIPAA, and safeguards sensitive information.",
			},
			{
				label: "Efficient",
				text: "Enhances security management with automated responses, patch enforcement, and firewall integration.",
			},
			{
				label: "Seamless Integration",
				text: "Compatible with existing network infrastructure and scalable across maritime and remote operations.",
			},
		],
	},
	{
		id: "onemonitor",
		title: "ONEMONITOR",
		photo: img2,
		description:
			"Software-controlled CCTV system optimised for real-time remote surveillance, even in low-bandwidth environments.",
		features: [
			{
				label: "Cost-Effective",
				text: "Enables secure, simultaneous monitoring of remote assets in real-time to enhance operational oversight.",
			},
			{
				label: "Secure",
				text: "Employs AES 256-bit encryption to protect communication between remote sites and monitoring applications.",
			},
			{
				label: "Efficient",
				text: "Enhances operational efficiency by optimising remote asset management, field personnel coordination, and revenue control.",
			},
			{
				label: "Flexible Transmission",
				text: "Offers adjustable resolution, bandwidth control, and live multi-camera view for advanced surveillance capabilities.",
			},
			{
				label: "Seamless Integration",
				text: "Easily adds remote monitoring to existing CCTV setups and is fully compatible with cellular and satcom platforms.",
			},
		],
	},
	{
		id: "iec-social",
		title: "IEC Voucher Manager ",
		photo: img3,
		description:
			"Enterprise platform enabling controlled multi-user connectivity with centralised management, structured access, and scalable deployment across remote and maritime environments.",
		features: [
			{
				label: "Cost-Effective",
				text: "Manages voucher allocation, user access, and consumption through a unified dashboard with real-time visibility and policy-based configuration.",
			},
			{
				label: "User Access",
				text: "Captive portal enables user authentication to access corporate allowances based on employer ID or voucher number.",
			},
			{
				label: "Operational Efficiency",
				text: "Ensures consistent policy enforcement across multiple sites with real-time monitoring and simplified administration.",
			},
			{
				label: "Scalable Integration",
				text: "Seamlessly integrates into hybrid connectivity environments (LEO/GEO/LTE) with global deployment and 24/7 support.",
			},
		],
		cta: "SEND REQUEST",
	},
];

const VouchersConfigList = () => {
	const { token, permissions } = useSelector((state) => state.auth.user);
	const voucherMangementConfig = permissions.find(
		(resource) => resource.resource_name === "iec_voucher_manager",
	);

	const authorizedPermissions = voucherMangementConfig?.permissions || [];

	const canRequestVoucher = checkPermission(authorizedPermissions, "submit voucher request");
	const isTablet = useIsTablet();

	const [openModalConfigVoucher, setOpenModalConfigVoucher] = useState({
		open: false,
		id: null,
	});

	const handleOpenModalConfigVoucherr = (id) => {
		setOpenModalConfigVoucher({
			open: true,
			id,
		});
	};
	return (
		<div className="px-2 pt-20 pb-6 md:px-6">
			{isTablet && <ModulesHeader subModuleTitle="IEC Voucher Manager" />}

			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
				{customers.map((customer) => (
					<CustomerCard
						key={customer.id}
						customer={customer}
						isPermitted={canRequestVoucher}
						handlehandleRequestVoucher={() => {
							handleOpenModalConfigVoucherr(customer.id);
						}}
					/>
				))}
			</div>
			{openModalConfigVoucher.open && (
				<VouchersConfigModal
					isOpen={openModalConfigVoucher?.open}
					id={openModalConfigVoucher.id}
					closeModal={() =>
						setOpenModalConfigVoucher({
							open: false,
							id: null,
						})
					}
				/>
			)}
		</div>
	);
};

export default VouchersConfigList;
